import classNames from 'classnames';
import createReactClass from 'create-react-class';
import React from 'react';

const BadgeDropdown = createReactClass({
  getInitialState() {
    return { isOpen: false };
  },

  render() {
    return (
      <div className={classNames('badgeDropdown', this.props.className)}>
        <span
          className="badgeDropdown-badge badgeDropdown-hoverBadge"
          onMouseOver={this.props.disabled ? undefined : this.handleOpenDropdown}
        >
          {this.props.badgeText}
        </span>

        <div className="badgeDropdown-dropdown-container">{this.state.isOpen && this.renderList()}</div>
      </div>
    );
  },

  handleOpenDropdown() {
    this.setState({ isOpen: true });
  },

  handleCloseDropdown() {
    this.setState({ isOpen: false });
  },

  renderList() {
    return (
      <div className="badgeDropdown-dropdown" onMouseLeave={this.handleCloseDropdown}>
        <div className="badgeDropdown-dropdown-header">{this.props.badgeText}</div>
        <ul>{this.props.items.sort(itemCompare).map(this.renderItem)}</ul>
      </div>
    );
  },

  renderItem(item) {
    return (
      <li key={item.id}>
        <span className="badgeDropdown-badge badgeDropdown-badge-item">{item.name}</span>
      </li>
    );
  },
});

function itemCompare(lhs, rhs) {
  return lhs.name.localeCompare(rhs.name);
}

export default BadgeDropdown;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/lib/badge_dropdown.jsx